<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.house_goods_type, 'Tip bunuri')"
      :items="goodsTypes"
      item-title="name"
      item-value="id"
      name="goods_type"
      :loading="loading"
      :disabled="loading"
      v-model="selectedGoodsType"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useHouseStore } from '~/plugins/store/house';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { GoodsType } from '~/types/House';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => GoodsType | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-house-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();
    const selectedGoodsType = ref(modelValue.value ? modelValue.value : null);
    const goodsTypes = ref<GoodsType[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref<string[]>([]);

    onMounted(async () => {
      loading.value = true;
      goodsTypes.value = await houseStore.getGoodsTypeList(['imobil']);
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      loading.value = false;
      const isValid = !!selectedGoodsType.value;
      emit('validation-house-status', { field: 'goods_type', isValid });

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'goods_type') {
          if (!selectedGoodsType.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-house-status', { field: 'goods_type', isValid: true });
          }
        }
      });
    });

    watch(selectedGoodsType, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (newValue && (newValue.id !== selectedGoodsType.value?.id)) {
        selectedGoodsType.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-house-status', { field: 'goods_type', isValid });
    });

    return {
      selectedGoodsType,
      translationList,
      translation,
      goodsTypes,
      loading,
      error,
    };
  },
});
</script>